export default {
  setReturnFlightSchema(configSettings) {
    let origin = []
    configSettings.departureAirport.forEach(departure => {
      origin.push({
        type: departure.type,
        value: departure.value
      })
    })
    let arrival = []
    configSettings.arrivalAirport.forEach(arrivalAirport => {
      arrival.push({
        type: arrivalAirport.type,
        value: arrivalAirport.value
      })
    })
    return JSON.stringify({
      config: {
        searchid: '',
        country: configSettings.country,
        language: configSettings.language,
        action: 's',
        mode: 'p',
        execmode: 'l',
        linktarget: 'a',
        nextpoll: 3,
        cabin: 'Y',
        pagination: {
          offset: 0,
          count: configSettings.count
        },
        selection: {
          type: 'oneshot'
        },
        sorting: [
          {
            type: 'price',
            order: 'ASC'
          }
        ],
        passenger: configSettings.passengers,
        baggageconfig: 0,
        attribution: {
          product: configSettings.product,
          subcategory: 'bananas',
          pagetype: 'conversion',
          pageid: configSettings.pageid.toString(),
          usersession: 'none'
        }
      },
      portions: [
        {
          origin: origin,
          destination: arrival,
          dep: {
            start: configSettings.departureDepTime.start
          },
          duration: configSettings.duration
        },
        {
          origin: arrival,
          destination: origin,
          dep: {
            end: configSettings.departureDepTime.end
          }
        }
      ],
      filters: {
        noopenjaws: {
          origin: {
            active: true,
            type: 'airport'
          },
          destination: {
            active: true,
            type: 'airport'
          }
        },
        connectioncount: configSettings.connectioncount
      }
    })
  },
  setOneWayFlightSchema(configSettings) {
    let origin = []
    configSettings.departureAirport.forEach(departure => {
      origin.push({
        type: departure.type,
        value: departure.value
      })
    })
    return JSON.stringify({
      config: {
        searchid: '',
        country: configSettings.country,
        language: configSettings.language,
        action: 's',
        mode: 'p',
        execmode: 'l',
        linktarget: 'a',
        nextpoll: 3,
        cabin: configSettings.cabin,
        pagination: {
          offset: 0,
          count: configSettings.count
        },
        selection: {
          type: 'oneshot'
        },
        sorting: [
          {
            type: 'price',
            order: 'ASC'
          }
        ],
        passenger: configSettings.passengers,
        baggageconfig: 0,
        attribution: {
          product: configSettings.product,
          subcategory: 'bananas',
          pagetype: 'conversion',
          pageid: configSettings.pageid,
          usersession: 'none'
        }
      },
      portions: [
        {
          origin: origin,
          destination: [
            { type: 'airport', value: configSettings.arrivalAirport }
          ],
          dep: configSettings.departureDepTime
        }
      ],
      filters: {
        connectioncount: configSettings.connectioncount
      }
    })
  }
}
